import React from "react";
import "./VirasatV2InputComponents.scss"



const VirasatV2InputComponents = ({ label, value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {


    return (
        <div className="VirasatV2InputComponents-VirasatV2Default">
            <div className="input-label">
                {label}
                {required && <span className="input-req">* </span>}
            </div>
            <div className={`VirasatV2InputComponents-VirasatV2Default-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="VirasatV2InputComponents-VirasatV2Default-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default VirasatV2InputComponents
